import { Injectable } from '@angular/core';
import { liveQuery } from 'dexie';
import { from } from 'rxjs';
import { db } from '../database/db';
import EntityManager from '../database/EntityManager';
import { Device } from '../database/models';

@Injectable({
  providedIn: 'root',
})
export class DevicesService extends EntityManager<Device, 'device'> {
  public values$ = from(
    liveQuery(async () => {
      //TODO: put under behavior into Entity Manager.
      // Do not emit values until the API has returned a response.
      const res = await db._configuration.get({ name: this.name });
      let devices: Device[] = null;
      if (res) {
        devices = await this.getAll();
      }

      return devices;
    })
  );

  constructor() {
    super({
      name: 'device',
      model: Device,
    });
  }
}
